export default {
	namespaced: true,
	state: {
		winHeight: 0, //窗口整体高度
	},
	mutations: {
		// 更新窗口高度
		setWinHeight(state, h) {
			state.winHeight = h
		},
	}
}
